import { Dialog } from "@headlessui/react";
import { AlertTriangleIcon } from "../../../icons";

type ConfirmModalProps = {
  title: string;
  message: string;
  onConfirm: () => void;
  confirmButtonText?: string;
  onCancel: () => void;
  cancelButtonText?: string;
};
const ConfirmModal = ({
  title,
  message,
  onConfirm,
  confirmButtonText = "Confirm",
  onCancel,
  cancelButtonText = "Cancel",
}: ConfirmModalProps) => {
  return (
    <>
      <div className="sm:flex sm:items-start">
        <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
          <AlertTriangleIcon className="h-6 w-6 text-red-400" />
        </div>
        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
          <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
            {title}
          </Dialog.Title>
          <div className="mt-2">
            <p className="text-sm text-gray-500">{message}</p>
          </div>
        </div>
      </div>
      <div className="mt-5 sm:mt-4 sm:ml-10 sm:pl-4 sm:flex">
        <button
          type="button"
          className="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 hover:bg-red-700 focus:ring-red-500 text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 sm:w-auto sm:text-sm"
          onClick={onConfirm}
        >
          {confirmButtonText}
        </button>
        <button
          type="button"
          className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 px-4 py-2 bg-white text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
          onClick={onCancel}
        >
          {cancelButtonText}
        </button>
      </div>
    </>
  );
};

export default ConfirmModal;
